import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=3bb33c8f&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb33c8f')) {
      api.createRecord('3bb33c8f', component.options)
    } else {
      api.reload('3bb33c8f', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=3bb33c8f&", function () {
      api.rerender('3bb33c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/comp/ErrorMessage.vue"
export default component.exports